import { isMock } from '../config'
import { acompanantesMock } from './mock'
import { acompanantesReal } from './real'
import type { AcompanantesService } from './types'

export const acompanantesService: AcompanantesService = isMock('acompanantes') ? acompanantesMock : acompanantesReal
export type { AcompanantesService, Invitation, InviteChannel, InviteInput } from './types'
